import { ref } from "vue";
import axios from "axios";

const BASE_URL = import.meta.env.VITE_API_BASE_URL;

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

export const useApi = () => {
    const isSubmitting = ref(false);
    const error = ref(null);

    const getAuthToken = () => {
        return sessionStorage.getItem('jwt');
    }

    const handleRequest = async (method, url, data = null) => {
        try {
            isSubmitting.value = true;
            error.value = null;

            const token = getAuthToken();

            const config = {
                method,
                url,
                data,
                headers: token ? { Authorization: `Bearer ${token}`} : {}
            }
            return await axiosInstance(config);
        } catch (err) {
            if (err.response) {
                throw new Error(err?.response?.data?.message);
            } else if (err.request) {
                throw new Error(`Aucune réponse du serveur ${err.request}`);
            } else {
                throw new Error(`Erreur Axios ${err}`);
            }
        } finally {
            isSubmitting.value = false;
        }
    }

    const get_data = (url) => handleRequest('get', url);
    const post_data = (url, data) => handleRequest('post', url, data);
    const put_data = (url, data) => handleRequest('put', url, data);
    const del_data = (url) => handleRequest('delete', url);

    return {
        get_data,
        post_data,
        put_data,
        del_data,
        isSubmitting,
        error
    }
}